import type { ProductDetailsRoot } from '@repo/sdk'

import type { ProductCreateFormValues } from './ProductCreateFormTypes'

export function mapProductToFormValues(product: ProductDetailsRoot): ProductCreateFormValues {
  return {
    name: product.name,
    description: product.description ?? undefined,
    productCategoryIds: product.categories.map((c) => c.id),
    price: product.price.amount,
    shippingFee: product.shippingFee?.amount ?? 0,
    quantity: product.quantity,
    images: product.images,
    salesChannel: product.salesChannel,
  }
}
